"use client";

import { useTranslations } from "next-intl";
import React, { FC, useContext } from "react";

import DesktopFilters from "@/components/AvailableUnitsList/DesktopFilters";
import MobileFilters from "@/components/AvailableUnitsList/MobileFilters";
import UnitsTableDesktop from "@/components/AvailableUnitsList/UnitsTableDesktop";
import UnitsTableMobile from "@/components/AvailableUnitsList/UnitsTableMobile";
import AnchorLink from "@/components/ui/AnchorLink/AnchorLink";
import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import { AvailableUnitsListProps } from "@/types";

import "./UnitsTable.css";

export const supportedFilters = ["unitViews", "planType"];

const Content: FC<AvailableUnitsListProps> = ({
  bedrooms,
  propertyType,
  project,
  propertyTypeUrl,
  hasOtherSolutions,
  unitName,
  serverSideCookieCurrency,
  currencyFromApiRes,
  isBelongToCommunity,
  matchedCommunity,
}) => {
  const t = useTranslations();
  const propertyTypeTitle =
    (bedrooms && bedrooms !== 0 ? t("label.propertyType.brName", { bedrooms }) : t("label.propertyType.studio")) +
    " " +
    t(`label.propertyType.type.${propertyType}`);
  return (
    <div id="AUL-component" className="w-full md:w-22\/24 px-m md:px-0 mx-auto">
      <UnitsTableDesktop
        unitName={unitName}
        serverSideCookieCurrency={serverSideCookieCurrency}
        currencyFromApiRes={currencyFromApiRes}
        isBelongToCommunity={isBelongToCommunity}
        matchedCommunity={matchedCommunity}
      />
      <UnitsTableMobile isBelongToCommunity={isBelongToCommunity} matchedCommunity={matchedCommunity} />
      {hasOtherSolutions && propertyTypeUrl && (
        <>
          <div className="px-m md:px-0">
            <h3 className="text-center text-m font-secondary font-secondary-light pt-l pb-s">
              {t("aul.otherSolutions", { name: propertyTypeTitle, project })}
            </h3>
          </div>
          <div className="block w-full mx-auto text-center my-l">
            <AnchorLink href={propertyTypeUrl}>
              <Button size={ButtonSize.MEDIUM} theme={ButtonTheme.BLACK} type="button" variant={ButtonVariant.SECONDARY}>
                {t("aul.viewAllSolutions", {
                  name: bedrooms && bedrooms !== 0 ? t("label.propertyType.brName", { bedrooms }) : t("label.propertyType.studio"),
                })}
              </Button>
            </AnchorLink>
          </div>
        </>
      )}
    </div>
  );
};

const AvailableUnitsList: FC<AvailableUnitsListProps> = (props) => {
  return <></>;
};
export default AvailableUnitsList;
